import { useEffect, useState } from 'react';

const useModalClass = (isOpen: boolean) => {
  const [classList, setClassList] = useState<string>('modal modal-sm');

  useEffect(() => {
    if (isOpen) {
      setClassList('modal modal-sm active');
    } else {
      setClassList('modal modal-sm');
    }
  }, [isOpen]); // eslint-disable-line

  return classList;
};

export default useModalClass;
